import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../../protected-area/interfaces/api-response.interface';
import { ApiResponseWithPagination } from '../../protected-area/interfaces/pagination.interface';
import {
  MOCK_MUNICIPIOS,
  MOCK_ORGANOS,
  MOCK_PUESTOS,
  MOCK_ROLES,
  MOCK_SISTEMAS,
  MOCK_TIPOS_ORGANO,
} from '../mock-data/catalogs.mock';

/**
 * Interceptor para simular respuestas de la API durante el desarrollo.
 * Se activa si environment.development?.useMockData es true.
 */
@Injectable()
export class MockApiInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Si no estamos en desarrollo o useMockData es false, pasar la petición
    if (!environment.development?.useMockData) {
      return next.handle(request);
    }

    const { url, method } = request;

    // Simulación de los endpoints de Catálogos
    if (url.includes('/Sistemas')) {
      console.log('Sistemas');
      return this.handleMockRequest(MOCK_SISTEMAS, method, 'Sistema');
    }
    if (url.includes('/Organos')) {
      console.log('Organos');
      return this.handleMockRequest(MOCK_ORGANOS, method, 'Órgano');
    }
    if (url.includes('/TiposOrgano')) {
      console.log('TiposOrgano');
      return this.handleMockRequest(MOCK_TIPOS_ORGANO, method, 'Tipo de Órgano');
    }
    if (url.includes('/Puestos')) {
      console.log('Puestos');
      return this.handleMockRequest(MOCK_PUESTOS, method, 'Puesto');
    }
    if (url.includes('/RolesCatalogo') || url.includes('/Roles')) {
      console.log('roles');
      return this.handleMockRequest(MOCK_ROLES, method, 'Rol');
    }
    if (url.includes('/Municipios')) {
      console.log('Municipios');
      return this.handleMockRequest(MOCK_MUNICIPIOS, method, 'Municipio');
    }

    // Para cualquier otra petición, continuar normalmente
    return next.handle(request);
  }

  /**
   * Genera una respuesta simulada basada en el método HTTP y los datos proporcionados.
   */
  private handleMockRequest(
    data: unknown[],
    method: string,
    entityName: string,
  ): Observable<HttpEvent<unknown>> {
    let body: ApiResponse<unknown> | ApiResponseWithPagination<unknown>;

    switch (method) {
      case 'GET':
        body = {
          statusCode: 200,
          isSuccess: true,
          message: 'Datos recuperados exitosamente',
          data: data,
          customCode: 1,
          paginationMetadata: {
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            totalRecords: data.length,
          },
        } as ApiResponseWithPagination<unknown>;
        break;

      case 'POST':
        body = {
          statusCode: 201,
          isSuccess: true,
          message: `${entityName} creado exitosamente`,
          data: data[0],
        } as ApiResponse<unknown>;
        break;

      case 'PUT':
      case 'PATCH':
        body = {
          statusCode: 200,
          isSuccess: true,
          message: `${entityName} actualizado exitosamente`,
          data: data[0],
        } as ApiResponse<unknown>;
        break;

      case 'DELETE':
        body = {
          statusCode: 200,
          isSuccess: true,
          message: `${entityName} eliminado exitosamente`,
          data: null,
        } as ApiResponse<null>;
        break;

      default:
        return of(new HttpResponse({ status: 200, body: { success: true } }));
    }

    // Simular un pequeño retraso de red (500ms)
    return of(new HttpResponse({ status: body.statusCode || 200, body })).pipe(delay(500));
  }
}
